import React from 'react';

import { ComposePanelContainer } from '../ComposePanel/compose-panel.container';
import { HistoryPanel } from '../HistoryPanel/history-panel.component';
import {
  CommunicationPanelTab,
  setCommunicationPanelTab,
  useCommunicationPanelTab,
  useIsCommunicationSendInFlight
} from '../../../lib/stores/communication.store';
import { Body, StyledTab, StyledTabs } from './communication-panel.styles';

export const CommunicationPanelBody: React.FC = () => {
  const activeTab = useCommunicationPanelTab();
  // Lock tab switching while a send is in flight: a Compose→History switch
  // unmounts the compose container and would drop its post-success/error state.
  const isSendInFlight = useIsCommunicationSendInFlight();
  const handleChange = (_: unknown, next: CommunicationPanelTab) => {
    if (isSendInFlight) return;
    setCommunicationPanelTab(next);
  };

  return (
    <>
      <StyledTabs
        value={activeTab}
        onChange={handleChange}
        textColor="primary"
      >
        <StyledTab value="compose" label="Compose" />
        <StyledTab value="history" label="History" disabled={isSendInFlight} />
      </StyledTabs>
      <Body>
        {activeTab === 'compose' && <ComposePanelContainer />}
        {activeTab === 'history' && <HistoryPanel />}
      </Body>
    </>
  );
};
